import 'angular';
import AppConstants from '../gorillaboy/AppConstants';
import './templates/lock_and_edit.html';
import {RootScope} from '../types/angular-types';

angular.module('GorillaBoy.directives')
.directive('lockAndEdit', ['$rootScope', '$log', 'SignalProvider', ($rootScope, $log, SignalProvider) => {
    return {
        scope: {
            doc: '<',
            editWithCompanion: '&onEditClicked',
            lockFile: '&lockFile',
            unlockFile: '&unlockFile'
        },
        templateUrl: './directives/templates/lock_and_edit.html',
        link: ($scope, $element, $attrs) => {
            $scope.modalState = {
                show: false,
                editWithLock: true
            };

            $scope.modalState.editWithLock = true;

            $scope.dismiss = function() {
                $scope.modalState.show = false;
            }

            $scope.isDocumentCheckedOutByAnApp = function(doc) {
                return (doc.CheckoutInfo && doc.CheckoutInfo.LockType === AppConstants.LOCK_TYPES.APP);
            };

            $scope.isDocumentCheckedOut = function(doc) {
                return !!(doc.CheckoutInfo);
            };

            $scope.onLaunchClicked = function() {
                if ($scope.isDocumentCheckedOut($scope.doc) && $scope.isDocumentCheckedOutByAnApp($scope.doc)) {
                    $scope.dismiss();
                    $log.debug('lock and edit model dismissed because document is locked. The document metadata: ' + JSON.stringify($scope.doc));
                    return;
                }

                if (!$scope.isDocumentCheckedOut($scope.doc) && $scope.modalState.editWithLock) {
                    $scope.lockFile({doc: $scope.doc}).then(function() {
                        $scope.editWithCompanion({doc: $scope.doc});
                        $log.debug('lock file and edit. The document Id: ' + $scope.doc.Id);
                    });
                } else if ($scope.isDocumentCheckedOut($scope.doc) && !$scope.modalState.editWithLock) {
                    $scope.unlockFile({doc: $scope.doc}).then(function() {
                        $scope.editWithCompanion({doc: $scope.doc});
                        $log.debug('unlock file and edit. The document Id: ' + $scope.doc.Id);
                    });
                } else {
                    $scope.editWithCompanion({doc: $scope.doc});
                    $log.debug('lock and edit without changing lock state. The document Id: ' + $scope.doc.Id);
                }

                $scope.dismiss();
            }

            $scope.$on(SignalProvider.InfoBox.ShowEditWithLockModal, function(event) {
                $scope.modalState.show = true;
                $scope.modalState.editWithLock = true;
            });
        }
    };
}])